import { defineComponent } from 'vue'
import { Field } from 'vant'
import './field-compat.less'

const PRIMARY_BG_CLASS = 'fsw-van-field'

export default defineComponent({
  name: 'VanField',
  props: {
    // 多选框选择其他时，右侧下划线形式输入框 ____
    isOtherText: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { attrs, slots }) {
    return () => {
      const { class: cls, type, ...rest } = attrs as Record<string, unknown>
      const isTextarea = type === 'textarea'
      const { isOtherText } = props
      return (
        <Field
          scroll-to-error
          class={[
            cls,
            PRIMARY_BG_CLASS,
            {
              'fsw-van-field--textarea': isTextarea,
              'fsw-van-field--other-text': isOtherText,
            },
          ]}
          {...rest}
          v-slots={slots}
        />
      )
    }
  },
})
